import React from 'react'

function Banner() {
    return (
        <div>
            <img src={'https://i.ibb.co/1ML3c4L/26-Inch-Mountain-Bicycle-Weight-Forbike-Store-2020-Cheap-Downhill-Bike-Mountain-Bike-Disc-Bycycle.jpg '} />
        </div>
    )
}

export default Banner
